import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IFaqQuestion } from 'shared/types/faq.interface';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { TranslateModule } from '@ngx-translate/core';
import { YoutubeVideoComponent } from '../youtube-video/youtube-video.component';

@Component({
  selector: 'faq-answer',
  templateUrl: './faq-answer.component.html',
  styleUrl: './faq-answer.component.scss',
  standalone: true,
  imports: [NzCollapseModule, TranslateModule, YoutubeVideoComponent]
})
export class FaqAnswerComponent {
  @Input() questions: IFaqQuestion[];
  @Output() activeChange: EventEmitter<IFaqQuestion>;

  constructor() {
    this.activeChange = new EventEmitter<IFaqQuestion>();
  }

  public onActiveChange(childPanel: IFaqQuestion): void {
    this.activeChange.emit(childPanel);
  }
}
